import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import AuthView from './pages/Login/AuthView';

import { 
  AuthProvider, 
  AuthIsSignedIn, 
  AuthIsNotSignedIn, 
  AuthIsLoading, 
  AuthClientSignedIn,
  AuthServiceSignedIn,
  AuthSupportSignedIn,
  AuthFactorySignedIn
} from './context/AuthContextProvider';
import ACBView from './pages/ACBView/ACBView';
import Organization from './pages/Organization/Organization';
import { OrganizationList } from './pages/Organization/OrganizationListView';
import { CreateOrganization } from './pages/Organization/CreateOrganization';
import OrganizationEditView from './pages/Organization/OrganizationEditVIew';

import Loading from './pages/Loading/Loading';
import { PrimeReactProvider } from 'primereact/api';
import { SideBar } from './components/SideBar/SideBar';

import './styles/background.css'
import './styles/border-radius.css'
import './styles/elements.css'
import './styles/padding.css'
import './styles/text-colors.css'
import './styles/text-sizes.css'
import './styles/tables.css'
import './styles/inputs.css'
import './styles/flex.css'
import './styles/sizes.css'

import { ACBList } from './pages/ACBList/ACBList';
import { ErrorPage } from './pages/ErrorPage/ErrorPage';
import { UpdateCommission } from './pages/Commission/Commission';
import { CommissionReview } from './pages/Commission/CommissionReview';
import { UpdateCommissionComment } from './pages/Commission/CommissionComment';
import { AcbEditView } from './pages/ACBView/ACBEditView';
import { ConfirmPasswordView } from './pages/Login/ConfirmPassword';
import { Policy } from './pages/Policy/Policy';
import { CreateUser } from './pages/Users/CreateUser';
import { Users } from './pages/Users/Users';
import { UpdateSelf } from './pages/Users/UpdateSelf';
import { AcbChangeOrganization } from './pages/ACBView/ACBChangeOrg';


function App() {

  return (
    <div className="layout">
      <PrimeReactProvider>
        <AuthProvider>
          <AuthIsSignedIn>
            <Router>
              <SideBar/>
              <AuthClientSignedIn>
                  <Routes>
                    <Route path="/react/*" element={<Navigate replace to={"/react/organization"} />} />
                    <Route path="/react/acb/detail/:serial_number" element={<ACBView/>}  />
                    <Route path="/react/acb/:serial_number/edit" element={<AcbEditView/>} />
                    <Route path="/react/organization" element={ <Organization/> }  />
                    <Route path="/react/organization/:id/edit/:setting_option" element={ <OrganizationEditView/> }  />
                    <Route path="/react/profile" element={ <UpdateSelf/> }  />
                    <Route path="/react/error/:error_code" element={<ErrorPage/>}/>
                  </Routes>
              </AuthClientSignedIn>
              <AuthServiceSignedIn>
                {/* SERVICE */}
                  <Routes>
                    <Route path="/react/*" element={<Navigate replace to={"/react/acblist"} />} />
                    <Route path="/react/acblist" element={<ACBList/>}  />
                    <Route path="/react/acb/detail/:serial_number" element={<ACBView/>}  />
                    <Route path="/react/acb/:serial_number/edit" element={<AcbEditView/>} />
                    <Route path="/react/acb/:serial_number/update-commission" element={<UpdateCommission/>}  />
                    <Route path="/react/acb/:serial_number/comission-update-comment" element={<UpdateCommissionComment/>}  />

                    <Route path="/react/organization/list" element={ <OrganizationList/> } />
                    <Route path="/react/organization/:id?/details" element={ <Organization/> }  />
                    <Route path="/react/organization/:id?/edit/:setting_option" element={ <OrganizationEditView/> } />

                    <Route path="/react/profile" element={ <UpdateSelf/> }  />
                    <Route path="/react/error/:error_code" element={<ErrorPage/>}/>
                  </Routes>
              </AuthServiceSignedIn>
              <AuthSupportSignedIn>
                {/* SUPPORT */}
                  <Routes>
                    <Route path="/react/*" element={<Navigate replace to={"/react/acblist"} />} />
                    <Route path="/react/acblist" element={<ACBList/>}  />
                    <Route path="/react/acb/detail/:serial_number" element={<ACBView/>}  />
                    <Route path="/react/acb/:serial_number/edit" element={<AcbEditView/>} />
                    <Route path="/react/acb/:serial_number/change-organization" element={<AcbChangeOrganization/>} />
                    <Route path="/react/acb/:serial_number/update-commission" element={<UpdateCommission/>}  />
                    <Route path="/react/acb/:serial_number/comission-update-comment" element={<UpdateCommissionComment/>}  />

                    <Route path="/react/organization/list" element={ <OrganizationList/> }  />
                    <Route path="/react/organization/create" element={ <CreateOrganization/> } />
                    <Route path="/react/organization/:id?/details" element={ <Organization/> }  />
                    <Route path="/react/organization/:id?/edit/:setting_option" element={ <OrganizationEditView/> } />

                    <Route path="/react/users/list" element={ <Users/> }  />
                    <Route path="/react/users/create" element={ <CreateUser/> }/>
                    <Route path="/react/profile" element={ <UpdateSelf/> }  />
                    <Route path="/react/error/:error_code" element={<ErrorPage/>}/>
                  </Routes>
              </AuthSupportSignedIn>
              <AuthFactorySignedIn>
                {/* FACTORY */}
                  <Routes>
                    <Route path="/react/*" element={<Navigate replace to={"/react/acblist"} />} />
                    <Route path="/react/acblist" element={<ACBList/>}  />
                    <Route path="/react/acb/:serial_number/edit" element={<AcbEditView/>} />
                    <Route path="/react/acb/detail/:serial_number" element={<ACBView/>}  />
                    <Route path="/react/acb/:serial_number/update-commission" element={<UpdateCommission/>}  />
                    <Route path="/react/acb/:serial_number/review-commission" element={<CommissionReview/>}  />
                    <Route path="/react/acb/:serial_number/comission-update-comment" element={<UpdateCommissionComment/>}  />
                    <Route path="/react/profile" element={ <UpdateSelf/> } />
                    <Route path="/react/error/:error_code" element={<ErrorPage/>}/>
                  </Routes>
              </AuthFactorySignedIn>
            </Router>
          </AuthIsSignedIn>
          <AuthIsNotSignedIn>
            <Router>
                <Routes>
                  <Route path={"/react/login"} element={<AuthView />} />
                  <Route path={"/react/reset-password"} element={ <ConfirmPasswordView /> } />
                  <Route path="/react/policy" element={ <Policy /> } />
                  <Route path="/*" element={<Navigate replace to={"/react/login"} />} />
                </Routes>
            </Router>
          </AuthIsNotSignedIn>
          <AuthIsLoading>
            <Router>
              <Routes>
                <Route path="/react/*" element={<Loading />} />
              </Routes>
            </Router>
          </AuthIsLoading>
        </AuthProvider>
      </PrimeReactProvider>
    </div>

  );
}

export default App;
